// Check if Web Worker is supported
export const isWebWorkerSupported = (): boolean => {
    try {
        return typeof Worker !== 'undefined';
    } catch (_e) {
        return false;
    }
};
